import { CustomerCareRedeemGiftOrderWindowTitleSelector } from '../../../reducers/selectors/customer.selectors';
import { ORDER_ACCESS, ORDERING_ACCESS } from '../../../security.attributes';

// Registered in getReactRoutes when InvReactRedeemGiftOrderFlow is ON so
// Angular entry (quick action / deep link) lands on the React page.
export var REDEEM_GIFT_ORDER_STATE_NAME = 'index.customercare.customer.redeemGiftOrder';
export function routing($stateProvider) {
  $stateProvider.state(REDEEM_GIFT_ORDER_STATE_NAME, {
    url: '/redeemGiftOrder',
    template: '<redeem-gift-order></redeem-gift-order>',
    data: {
      windowTitle: CustomerCareRedeemGiftOrderWindowTitleSelector
    },
    securityAttributes: [ORDER_ACCESS],
    adminSecurityAttributes: [ORDERING_ACCESS]
  });
}